import {
  Settings,
  ShoppingCart,
  Clock,
  Calendar,
  Sliders,
  FileText,
  Truck,
  Users,
  Award
} from "react-feather";

const mcoMainSection = [
  {
    href: "/",
    title: "Scorecard",
    icon: Sliders
  },
  {
    href: "/products",
    title: "Productos",
    icon: ShoppingCart,
    children: [
      {
        href: "/products-overview/segments",
        title: "Segmentos",
      },
      {
        href: "/products-overview/business",
        title: "Negocios",
      },
      {
        href: "/products-sales-ranking",
        title: "Ranking de ventas", //ex Productos más vendidos
      },
    ]
  },
  {
    href: "/distributors",
    title: "Distribuidores",
    icon: Truck,
    children: [
      {
        href: "/distributors/distributors-overview",
        title: "Resumen",
      },
      {
        href: "/distributors/distributors-details",
        title: "Detalles",
      },
    ]
  },
  {
    href: "/customers",
    title: "Clientes",
    icon: Users,
    children: [
      {
        href: "/customers-overview",
        title:"Resumen",
      },
    ]
  },
  {
    href: "/benefits",
    title: "Beneficios",
    icon: Award,
    children: [
      {
        href: "/benefits/overview",
        title:"Resumen"
      },
      {
        href: "/benefits/corporatives",
        title:"Corporativos"
      },
      {
        href: "/benefits/banking-benefits",
        title:"Bancarios"
      },
      {
        href: "/benefits/massives",
        title:"Masivos"
      },
      {
        href: "/benefits/details",
        title:"Detalles"
       }
    ]
  },
  {
    href: "/reports",
    title: "Reportes",
    icon: FileText,
    children: [
      {
        href: "/reports/trade-report",
        title:"Reporte Comercial"
      },
      // {
      //   href: "/reports/buy-x-get-y",
      //   title:"Reporte compro X llevo Y"
      // },
      {
        href: "/reports/simple",
        title:"Reporte SIMPLE"
      },
      {
        href: "/reports/mix-boxes",
        title:"Cajas Surtidas"
      },
      {
        href: "/reports/users-mails",
        title: "Mailing"
      },
    ]
  },
  //metabase
  {
    href: "/",
    title: "METABASE",
    icon: ''
  },//resumen
  {
    href: "/mb-resume",
    title: "Resumen",
    icon: Sliders
  },
  {//Ventas
    href: "/mb-sales",
    title: "Ventas",
    icon: ShoppingCart,
    children: [
      {
        href: "/mb-sales/customers",
        title: "Clientes",
      },
      {
        href: "/mb-sales/distributors",
        title: "Distribuidores",
      },
    ]
  },
  {//Beneficios
    href: "/mb-beneficts",
    title: "Beneficios",
    icon: Award,
    children: [
      {
        href: "/mb-beneficts/mb-beneficts-summary",
        title: "Resumen",
      },
      {
        href: "/mb-beneficts/mb-beneficts-corporate",
        title: "Corporativos",
      },
      {
        href: "/mb-beneficts/mb-beneficts-bank",
        title: "Bancarios",
      },
      {
        href: "/mb-beneficts/mb-beneficts-masive",
        title: "Masivos",
      },
    ]
  },
  {
    href: "/mb-reports",
    title: "Reportes",
    icon: FileText,
    children: [
      {
        href: "/mb-reports",
        title:"Reporte Comercial"
      }
    ]
  },
  {
    href: "/mb-users",
    title: "Usuarios",
    icon: Users,
    children: [
      {
        href: "/mb-users",
        title:"Resumen",
      },
    ]
  }
];

const navItems = [
  {
    title: "",
    pages: mcoMainSection
  }
];

export default navItems;
